export const ALP = 'alp'
export const TLN = 'tln'
export const BTL = 'btl'

export default new Set([ALP, TLN, BTL])
